<div class="sectionTitle" [ngClass]="{'border-section': showBorder}" *ngIf="hasInclusions">
  {{ title | transloco }}
</div>

<div class="box-category" *ngFor="let inclusion of inclusions">
  <span class="icon {{inclusion.Type}}">
    <app-ds-icon
      [icon]="iconState(inclusion.Type)"
      [color]="classState(inclusion.Type)"
      [size]="16">
    </app-ds-icon>
  </span>
  <div class="content-category">
    <span class="title">
      {{ inclusion.RowName | capitalize }}
    </span>
    <span class="subtitle" *ngIf="rowNameEqualSubtitle(inclusion)">
      {{ obtainSubtitle(inclusion) | capitalize }}
    </span>
  </div>
</div>
